import React from 'react';
import Grid from '@mui/material/Grid2';
import Tab from './components/Tab/Save';
import Card from './components/Card/Save';
import Icon from './components/Icon/Save';
import Table from './components/Table/Save';
import Image from './components/Image/Save';
import Video from './components/Video/Save';
import Button from './components/Button/Save';
import Gallery from './components/Gallery/Save';
import Carousel from './components/Carousel/Save';
import Typography from './components/Typography/Save';
// import Accordion from './components/Accordion/Save';
import GameCard from './components/Template/GameCard/Save';
import CardModule from './components/Template/CardModule/Save';

const Widget = ({ widget, widgetStyle, widgetProps }) => {

    function parseSizeProps(size) {
        const defaultSize = { lg: 12, md: 12, sm: 12, xs: 12 };
        const finalSize = size ?? defaultSize;
        return Object.fromEntries(
            Object.entries(finalSize).map(([key, value]) => [
            key,
            Number.isNaN(parseInt(value, 10)) ? defaultSize[key] : parseInt(value, 10)
            ])
        );
    }

    const { type } = widget;
    const widgets = () => {
            switch (type) {
            case 'tab': return (<Tab widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'icon': return (<Icon widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'card': return (<Card widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'table': return (<Table widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'image': return (<Image widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'video': return (<Video widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'button': return (<Button widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'text': return (<Typography widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'gallery': return (<Gallery widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'carousel': return (<Carousel widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            // case 'accordion': return (<Accordion widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            //Premdate Components
            case 'gamecard': return (<GameCard widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            case 'cardModule': return (<CardModule widgetStyle={widgetStyle} widgetProps={widgetProps} />);
            default: return null;
            }
        }
        return (
            <Grid size={parseSizeProps(widgetProps?.itemSize)} sx={[{ height: widgetProps.containerHeight ?? 'unset' }]}>
                {widgets()}
            </Grid>
        )
}
export default React.memo(Widget);